import { icons as feather } from 'assets/icons/sets/feather';
import featherCloseX from 'assets/icons/feather/close-x.svg';
import remixCloseX from 'assets/icons/remix/close-x.svg';
import phosphorCloseX from 'assets/icons/phosphor/close-x.svg';
import khushmeenCloseX from 'assets/icons/khushmeen/close-x.svg';
import featherChevron from 'assets/icons/feather/chevron.svg';
import remixChevron from 'assets/icons/remix/chevron.svg';
import phosphorChevron from 'assets/icons/phosphor/chevron.svg';
import khushmeenChevron from 'assets/icons/khushmeen/chevron.svg';
import { IconComponent, IconSet, IconSlug } from 'types/icons';

export type IconMap = Partial<Record<IconSlug, IconComponent>>;

// feather ships in the entry: it is the default set and backs every gap, so it must resolve on
// the first paint. The rest are chunks.
const LOADERS: Record<IconSet, () => Promise<IconMap>> = {
  feather: () => Promise.resolve(feather),
  remix: () => import('assets/icons/sets/remix').then((m) => m.icons),
  phosphor: () => import('assets/icons/sets/phosphor').then((m) => m.icons),
  khushmeen: () => import('assets/icons/sets/khushmeen').then((m) => m.icons)
};

export const loadIconSet = (set: IconSet): Promise<IconMap> => LOADERS[set]();

export const preloadIconSet = (set: IconSet | null): void => {
  if (set) LOADERS[set]();
};

export const resolveIcon = (
  icons: IconMap | null,
  set: IconSet,
  slug: IconSlug
): { Svg: IconComponent; set: IconSet } | null => {
  const own = icons?.[slug];

  if (own) return { Svg: own, set };

  const fallback = feather[slug];

  return fallback ? { Svg: fallback, set: 'feather' } : null;
};

// mask-image needs a URL synchronously, so these two slugs are imported statically.
const ICON_URLS: Partial<Record<IconSlug, Record<IconSet, string>>> = {
  'close-x': {
    feather: featherCloseX,
    remix: remixCloseX,
    phosphor: phosphorCloseX,
    khushmeen: khushmeenCloseX
  },
  chevron: {
    feather: featherChevron,
    remix: remixChevron,
    phosphor: phosphorChevron,
    khushmeen: khushmeenChevron
  }
};

export const getIconUrl = (set: IconSet, slug: IconSlug): string | undefined =>
  ICON_URLS[slug]?.[set];
